"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Tab", {
  enumerable: true,
  get: function get() {
    return _Tab.default;
  }
});
Object.defineProperty(exports, "TabPanel", {
  enumerable: true,
  get: function get() {
    return _TabPanel.default;
  }
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _console = require("@instructure/console");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _keycode = _interopRequireDefault(require("keycode"));

var _View = _interopRequireDefault(require("@instructure/ui-layout/lib/components/View"));

var _uiThemeable = _interopRequireDefault(require("@instructure/ui-themeable"));

var _uiPropTypes = require("@instructure/ui-prop-types");

var _ThemeablePropTypes = _interopRequireDefault(require("@instructure/ui-themeable/lib/utils/ThemeablePropTypes"));

var _matchComponentTypes = _interopRequireDefault(require("@instructure/ui-utils/lib/react/matchComponentTypes"));

var _safeCloneElement = _interopRequireDefault(require("@instructure/ui-utils/lib/react/safeCloneElement"));

var _uid = _interopRequireDefault(require("@instructure/uid"));

var _uiTestable = _interopRequireDefault(require("@instructure/ui-testable"));

var _Tab = _interopRequireDefault(require("./Tab"));

var _TabPanel = _interopRequireDefault(require("./TabPanel"));

var _theme = _interopRequireDefault(require("./theme"));

var _dec, _dec2, _class, _class2, _temp;

var styles = {
  componentId: 'klzhG',
  template: function template(theme) {
    return "\n\n.klzhG_GKUc,.klzhG_cAug{display:flex;flex-flow:row wrap}\n\n.klzhG_GKUc{background:".concat(theme.minimalBackground || 'inherit', "}");
  },
  'minimal': 'klzhG_GKUc',
  'simple': 'klzhG_cAug'
};
var TabList = (
/**
---
category: components
---
**/
_dec = (0, _uiTestable.default)(), _dec2 = (0, _uiThemeable.default)(_theme.default, styles), _dec(_class = _dec2(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(TabList, _Component);

  function TabList(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TabList);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TabList).call(this));

    _this.handleClick = function (tabIndex, e) {
      var tab = _this.getTab(tabIndex);

      if (!tab.props.disabled) {
        _this.setSelected(tabIndex);
      }
    };

    _this.handleEnter = function (tabIndex, e) {
      if (e.keyCode !== _keycode.default.codes.enter && e.keyCode !== _keycode.default.codes.return) {
        return;
      }

      var tab = _this.getTab(tabIndex);

      if (!tab.props.disabled) {
        _this.setSelected(tabIndex);
      }
    };

    _this.handleKeyDown = function (tabIndex, e) {
      var index = _this.selectedIndex;
      var preventDefault = false;

      if (e.keyCode === _keycode.default.codes.up || e.keyCode === _keycode.default.codes.left) {
        // Select next tab to the left
        index = _this.getIndex(index, -1);
        preventDefault = true;
      } else if (e.keyCode === _keycode.default.codes.down || e.keyCode === _keycode.default.codes.right) {
        // Select next tab to the right
        index = _this.getIndex(index, 1);
        preventDefault = true;
      }

      if (preventDefault) {
        e.preventDefault();
      }

      _this.setSelected(index);
    };

    _this.state = {
      focus: props.focus
    };

    if (typeof props.selectedIndex === 'undefined') {
      _this.state.selectedIndex = props.defaultSelectedIndex;
    }

    _this._tabs = [];
    _this._panels = [];
    _this._srTabs = [];
    return _this;
  }

  (0, _createClass2.default)(TabList, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this$props = this.props,
          focus = _this$props.focus,
          selectedIndex = _this$props.selectedIndex;
      var nextFocus = nextProps.focus,
          nextSelectedIndex = nextProps.selectedIndex;

      if (nextFocus !== focus || nextSelectedIndex !== selectedIndex) {
        this.setState({
          focus: nextFocus
        });
      }
    }
  }, {
    key: "setSelected",
    value: function setSelected(index) {
      var _this2 = this;

      var selectedIndex; // Check index boundary

      /*#__PURE__*/
      (
      /*#__PURE__*/
      0, _console.error)(this.isValidIndex(index), "[TabList] Invalid tab index: '".concat(index, "'."));

      var handleChange = function handleChange() {
        if (typeof selectedIndex !== 'undefined' && typeof _this2.props.onChange === 'function') {
          _this2.props.onChange(index, selectedIndex);
        }
      };

      if (typeof this.props.selectedIndex === 'undefined') {
        this.setState(function (state, props) {
          selectedIndex = state.selectedIndex;

          if (index !== selectedIndex) {
            handleChange();
            return {
              selectedIndex: index,
              focus: true
            };
          } else {
            return state;
          }
        });
      } else {
        selectedIndex = this.props.selectedIndex;

        if (index !== selectedIndex) {
          handleChange();
        }
      }
    }
  }, {
    key: "getIndex",
    value: function getIndex(startIndex, step) {
      var count = this.tabs.length;
      var change = step < 0 ? step + count : step;

      /*#__PURE__*/
      (
      /*#__PURE__*/
      0, _console.error)(this.isValidIndex(startIndex), "[Tablist] Invalid tab index: '".concat(startIndex, "'"));
      var index = startIndex;

      do {
        index = (index + change) % count;
      } while (this.getTab(index).props.disabled);

      return index;
    }
  }, {
    key: "isValidIndex",
    value: function isValidIndex(index) {
      return index >= 0 && index < this.tabs.length;
    }
  }, {
    key: "getTab",
    value: function getTab(index) {
      return this._tabs[index];
    }
  }, {
    key: "createScreenReaderTab",
    value: function createScreenReaderTab(index, id, props) {
      var _this3 = this;

      return (0, _react.createElement)(_Tab.default, {
        variant: 'screenreader-only',
        ref: function ref(c) {
          _this3._srTabs[index] = c;
        },
        key: "sr-tab-".concat(id),
        id: "sr-tab-".concat(id),
        controls: "panel-".concat(id),
        index: index,
        selected: false,
        disabled: props.disabled,
        children: props.title,
        onKeyDown: this.handleEnter,
        onClick: this.handleClick
      });
    }
  }, {
    key: "createTab",
    value: function createTab(index, id, selected, props) {
      var _this4 = this;

      var focus = selected && this.state.focus;
      return (0, _react.createElement)(_Tab.default, {
        variant: this.props.variant,
        ref: function ref(c) {
          _this4._tabs[index] = c;

          if (typeof props.tabRef === 'function') {
            props.tabRef(c);
          }
        },
        key: "tab-".concat(id),
        id: "tab-".concat(id),
        controls: "panel-".concat(id),
        index: index,
        selected: selected,
        focus: focus,
        role: selected ? 'tab' : 'presentation',
        // only the selected tab should be visible to screen readers
        disabled: props.disabled,
        children: props.title,
        onClick: this.handleClick,
        onKeyDown: this.handleKeyDown
      });
    }
  }, {
    key: "clonePanel",
    value: function clonePanel(index, id, selected, panel) {
      var _this5 = this;

      return (0, _safeCloneElement.default)(panel, {
        ref: function ref(c) {
          _this5._panels[index] = c;
        },
        id: "panel-".concat(id),
        labelledBy: "tab-".concat(id),
        selected: selected,
        key: "panel-".concat(id),
        variant: this.props.variant,
        padding: panel.props.padding || this.props.padding,
        textAlign: panel.props.textAlign || this.props.textAlign
      });
    }
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var _this6 = this;

      var children = [];
      var ids = this.tabIds;
      var tabs = this.tabs;
      var count = tabs.length;

      _react.default.Children.forEach(this.props.children, function (child, index) {
        if ((0, _matchComponentTypes.default)(child, [_TabPanel.default])) {
          var selected = !child.props.disabled && _this6.selectedIndex === index;
          var id = ids[index]; // render screen reader only tabs before the selected tab

          if (selected) {
            for (var i = 0; i < index; i++) {
              children.push(_this6.createScreenReaderTab(i, ids[i], tabs[i].props));
            }
          }

          children.push(_this6.createTab(index, id, selected, child.props)); // render screen reader only tabs after the selected tab

          if (selected) {
            for (var _i = index + 1; _i < count; _i++) {
              children.push(_this6.createScreenReaderTab(_i, ids[_i], tabs[_i].props));
            }
          }

          children.push(_this6.clonePanel(index, id, selected, child));
        } else {
          children.push(child);
        }
      });

      if (this.state.focus) {
        // This fixes an issue with focus management.
        //
        // Ultimately, when focus is true, and an input has focus,
        // and any change on that input causes a state change/re-render,
        // focus gets sent back to the active tab, and input loses focus.
        //
        // Since the focus state only needs to be remembered
        // for the current render, we can reset it once the
        // render has happened.
        //
        // Don't use setState, because we don't want to re-render.
        this.state.focus = false; // eslint-disable-line react/no-direct-mutation-state
      }

      return children;
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_View.default, {
        className: (0, _classnames2.default)((0, _defineProperty2.default)({}, styles[this.props.variant], true)),
        maxWidth: this.theme[this.props.size],
        margin: this.props.margin,
        role: "tablist"
      }, this.renderChildren());
    }
  }, {
    key: "selectedIndex",
    get: function get() {
      return typeof this.props.selectedIndex === 'undefined' ? this.state.selectedIndex : this.props.selectedIndex;
    }
  }, {
    key: "tabIds",
    get: function get() {
      // cache tab ids for better performance and to prevent errors with animations
      var ids = this._tabIds || [];
      var diff = ids.length - this.tabs.length;

      while (diff++ < 0) {
        ids.push((0, _uid.default)('Tab'));
      }

      this._tabIds = ids;
      return ids;
    }
  }, {
    key: "tabs",
    get: function get() {
      return _react.default.Children.toArray(this.props.children).map(function (child) {
        return (0, _matchComponentTypes.default)(child, [_TabPanel.default]) && child;
      });
    }
  }]);
  TabList.displayName = "TabList";
  return TabList;
}(_react.Component), _class2.propTypes = {
  /**
  * children of type `TabPanel`
  */
  children: _uiPropTypes.Children.oneOf([_TabPanel.default, null]),
  variant: _propTypes.default.oneOf(['simple', 'minimal']),

  /**
  * the index (zero based) of the panel that should be selected on initial render
  */
  defaultSelectedIndex: _propTypes.default.number,

  /**
  * the index (zero based) of the panel that should be selected (should be accompanied by `onChange`)
  */
  selectedIndex: (0, _uiPropTypes.controllable)(_propTypes.default.number, 'onChange', 'defaultSelectedIndex'),

  /**
  * Call this function when the selected tab changes. When used with `selectedIndex`,
  * the component will not control its own state.
  */
  onChange: _propTypes.default.func,

  /**
  * the selected tab should be focused
  */
  focus: _propTypes.default.bool,
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),

  /**
  * Valid values are `0`, `none`, `auto`, `xxx-small`, `xx-small`, `x-small`,
  * `small`, `medium`, `large`, `x-large`, `xx-large`. Apply these values via
  * familiar CSS-like shorthand. For example: `margin="small auto large"`.
  */
  margin: _ThemeablePropTypes.default.spacing,

  /**
  * Valid values are `0`, `none`, `xxx-small`, `xx-small`, `x-small`,
  * `small`, `medium`, `large`, `x-large`, `xx-large`. Apply these values via
  * familiar CSS-like shorthand. For example: `padding="small x-large large"`.
  */
  padding: _ThemeablePropTypes.default.spacing,
  textAlign: _propTypes.default.oneOf(['start', 'center', 'end'])
}, _class2.defaultProps = {
  variant: 'simple',
  focus: false,
  defaultSelectedIndex: 0,
  padding: void 0,
  textAlign: void 0,
  size: void 0,
  selectedIndex: void 0,
  onChange: void 0,
  margin: void 0,
  children: null
}, _temp)) || _class) || _class);
exports.default = TabList;